import * as React from 'react'

export const CommaIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="40"
      viewBox="0 0 24 40"
      xmlns="http://www.w3.org/2000/svg"
      fill="#A3A3FF"
      {...props}>
      <path d="M0.799934 11.9999C0.800337 9.55419 1.60129 7.17582 3.08045 5.22808C4.55961 3.28034 6.63566 1.87032 8.99151 1.21337C11.3474 0.556424 13.8535 0.688673 16.1271 1.58992C18.4007 2.49116 20.3168 4.11186 21.5828 6.20446C22.8487 8.29705 23.3949 10.7465 23.1379 13.1787C22.8809 15.6109 21.8349 17.8921 20.1595 19.6739C18.4841 21.4557 16.2716 22.6401 13.8598 23.0463C11.4481 23.4524 8.96965 23.0579 6.80314 21.9231C7.55194 24.7007 8.60793 27.0271 9.87194 28.8831C12.3999 32.6015 15.7119 34.3999 19.1999 34.3999C19.8365 34.3999 20.4469 34.6528 20.897 35.1029C21.3471 35.553 21.5999 36.1634 21.5999 36.7999C21.5999 37.4364 21.3471 38.0469 20.897 38.497C20.4469 38.9471 19.8365 39.1999 19.1999 39.1999C13.8527 39.1999 9.16154 36.3743 5.90073 31.5839C2.66873 26.8287 0.799934 20.1183 0.799934 11.9999Z" />
    </svg>
  )
}

export const MdlCommaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 50 50"
    fill="#A3A3FF"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M35.417 6.25H14.6878V27L23.0003 43.625H33.3337L25.0628 27H35.417V6.25Z" />
  </svg>
)

export const ThunderIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="30"
    viewBox="0 0 16 30"
    fill="#8080FF"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M6.66667 19.0002H0L9.33333 0.333496V11.0002H16L6.66667 29.6668V19.0002Z" />
  </svg>
)

export const StarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#8080FF"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M18.3164 9.9733C19.322 9.1624 20.2018 8.20704 20.9274 7.1383C17.7663 7.18866 14.625 7.64918 11.5824 8.5083C8.55879 9.43263 5.66797 10.7456 2.98242 12.4143C4.17104 12.92 5.42802 13.2469 6.71242 13.3843M8.96642 7.9253C9.17444 6.17035 9.47823 4.42809 9.87642 2.7063C9.87642 2.7063 11.0074 3.4108 12.3489 5.4928" />
    <path d="M13.2541 18.1782C12.2342 19.7154 10.9705 21.0759 9.51261 22.2062C8.914 18.8901 8.62492 15.5254 8.64911 12.1557C8.65911 11.7222 8.67711 11.2927 8.70111 10.8697M15.0231 9.66675C17.2966 12.3583 19.3043 15.2635 21.0181 18.3417C18.1055 17.915 15.2737 17.052 12.6181 15.7817" />
  </svg>
)

export const DiscountIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="43"
    height="42"
    viewBox="0 0 43 42"
    fill="none"
    stroke="#FFE14D"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M14.06 28.5L29.06 13.5M2 33C2 33.7946 2.31525 34.5568 2.87656 35.1192C3.43787 35.6816 4.19939 35.9984 4.994 36H38.006C38.8006 35.9984 39.5621 35.6816 40.1234 35.1192C40.6848 34.5568 41 33.7946 41 33V26.898C39.7047 26.5467 38.561 25.7788 37.7456 24.7129C36.9302 23.6469 36.4883 22.3421 36.4883 21C36.4883 19.6579 36.9302 18.3531 37.7456 17.2871C38.561 16.2212 39.7047 15.4532 41 15.102V9C41 8.20539 40.6848 7.44324 40.1234 6.8808C39.5621 6.31836 38.8006 6.00159 38.006 6H4.994C4.19939 6.00159 3.43787 6.31836 2.87656 6.8808C2.31525 7.44324 2 8.20539 2 9V15.09C3.30566 15.4334 4.46084 16.1995 5.28518 17.2687C6.10951 18.3379 6.55658 19.6499 6.55658 21C6.55658 22.3501 6.10951 23.6621 5.28518 24.7313C4.46084 25.8005 3.30566 26.5666 2 26.91V33Z" />
    <path d="M15.5601 16.5C15.9579 16.5 16.3394 16.342 16.6207 16.0607C16.902 15.7794 17.0601 15.3978 17.0601 15C17.0601 14.6022 16.902 14.2206 16.6207 13.9393C16.3394 13.658 15.9579 13.5 15.5601 13.5C15.1622 13.5 14.7807 13.658 14.4994 13.9393C14.2181 14.2206 14.0601 14.6022 14.0601 15C14.0601 15.3978 14.2181 15.7794 14.4994 16.0607C14.7807 16.342 15.1622 16.5 15.5601 16.5ZM27.5601 28.5C27.9579 28.5 28.3394 28.342 28.6207 28.0607C28.902 27.7794 29.0601 27.3978 29.0601 27C29.0601 26.6022 28.902 26.2206 28.6207 25.9393C28.3394 25.658 27.9579 25.5 27.5601 25.5C27.1622 25.5 26.7807 25.658 26.4994 25.9393C26.2181 26.2206 26.0601 26.6022 26.0601 27C26.0601 27.3978 26.2181 27.7794 26.4994 28.0607C26.7807 28.342 27.1622 28.5 27.5601 28.5Z" />
  </svg>
)
